const ALLOWED_ENTER_TYPES = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url",
];

function handleSubmit(event) {
  const form = event.currentTarget;
  const submitter = event.submitter || document.activeElement;
  let allowed = false;

  if (submitter) {
    const tag = submitter.tagName;
    const type = (submitter.type || "").toLowerCase();
    if (tag === "BUTTON" && (type === "submit" || type === "")) {
      allowed = true;
    } else if (tag === "INPUT" && (type === "submit" || type === "image")) {
      allowed = true;
    }
  }

  if (!allowed) {
    const active = document.activeElement;
    if (active && form.contains(active)) {
      if (active.tagName === "TEXTAREA") {
        allowed = true;
      } else if (active.tagName === "INPUT") {
        allowed = ALLOWED_ENTER_TYPES.includes(
          (active.type || "").toLowerCase()
        );
      }
    }
  }

  if (!allowed) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(
        "[Decidim][Questionnaire] submit bloqueado (origem não permitida)",
        { submitter, activeElement: document.activeElement }
      );
    }
  }
}

function registerGuard() {
  document.querySelectorAll("form.answer-questionnaire").forEach((form) => {
    if (form.dataset.submitGuardAttached === "true") {
      return;
    }
    form.addEventListener("submit", handleSubmit, true);
    form.dataset.submitGuardAttached = "true";
  });
}

document.addEventListener("DOMContentLoaded", registerGuard);
document.addEventListener("turbolinks:load", registerGuard);
